import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./header and footer/Footer";
import "./css/style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAward,
  faHandshake,
  faCertificate,
  faGlobe,
  faUniversity,
  faShieldHalved,
  faCheckCircle,
  faFileContract,
  faUsers,
  faMedal,
  faBuilding,
  faStar
} from "@fortawesome/free-solid-svg-icons";

function Accreditations() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); }),
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );
    document.querySelectorAll(".reveal, .reveal-stagger").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const accreditations = [
    { icon: faUniversity, title: "Academic Accreditation", desc: "Our programs are recognized by leading academic accreditation bodies, ensuring the highest standards of educational quality and rigor across all course offerings." },
    { icon: faShieldHalved, title: "Quality Assurance", desc: "We maintain rigorous quality assurance processes aligned with international education standards, including regular course audits and continuous improvement protocols." },
    { icon: faCheckCircle, title: "Industry Recognition", desc: "Our certifications are recognized and valued by employers across 180+ countries, providing graduates with a competitive edge in the global job market." },
    { icon: faFileContract, title: "Regulatory Compliance", desc: "Full compliance with international education regulations, data protection laws (GDPR), and accessibility standards ensuring inclusive learning for all." },
  ];

  const affiliations = [
    { icon: faGlobe, title: "Global Education Alliance", desc: "Partnered with the Global Education Alliance to expand access to quality digital learning across underserved regions and developing nations worldwide." },
    { icon: faUsers, title: "International eLearning Consortium", desc: "Active member of the International eLearning Consortium, collaborating with institutions to advance best practices in online education and pedagogy." },
    { icon: faBuilding, title: "Corporate Training Partners", desc: "Trusted by multinational corporations for employee upskilling programs, with customized learning pathways tailored to organizational development goals." },
    { icon: faHandshake, title: "University Partnerships", desc: "Strategic partnerships with leading universities worldwide to offer co-branded degree programs, credit transfer pathways, and research collaborations." },
  ];

  const certTypes = [
    { icon: faCertificate, title: "Professional Certificates", desc: "Industry-specific certifications that validate your expertise and are recognized by employers and professional bodies globally." },
    { icon: faMedal, title: "Academic Certificates", desc: "Accredited academic certificates that can be used towards degree credit at partner institutions or for professional development." },
    { icon: faStar, title: "Skill-Based Badges", desc: "Micro-credentials and digital badges that showcase specific competencies, shareable on LinkedIn and professional portfolios." },
    { icon: faAward, title: "Completion Awards", desc: "Comprehensive program completion awards with unique verification codes, proving mastery of entire course pathways and specializations." },
  ];

  return (
    <div>
      <Navbar page={"accreditations"} />

      <div className="page-banner">
        <h1>Accreditations & Affiliations</h1>
        <p>Building trust through internationally recognized standards, partnerships, and certifications.</p>
      </div>

      {/* Accreditations */}
      <section style={{ padding: "80px 8%" }}>
        <div className="reveal" style={{ textAlign: "center", marginBottom: "48px" }}>
          <h2 style={{ fontFamily: "'Outfit', sans-serif", fontSize: "2.2rem", fontWeight: 800, color: "#0f172a", marginBottom: "8px" }}>
            Our Accreditations
          </h2>
          <p style={{ color: "#64748b", fontSize: "1.05rem", maxWidth: "600px", margin: "0 auto" }}>
            Meeting and exceeding global standards in digital education
          </p>
        </div>
        <div className="accred-grid reveal-stagger">
          {accreditations.map((item, i) => (
            <div key={i} className="accred-card">
              <div className="accred-icon"><FontAwesomeIcon icon={item.icon} /></div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Affiliations */}
      <section style={{ padding: "80px 8%", background: "#f8fafc" }}>
        <div className="reveal" style={{ textAlign: "center", marginBottom: "48px" }}>
          <h2 style={{ fontFamily: "'Outfit', sans-serif", fontSize: "2.2rem", fontWeight: 800, color: "#0f172a", marginBottom: "8px" }}>
            Strategic Affiliations
          </h2>
          <p style={{ color: "#64748b", fontSize: "1.05rem", maxWidth: "600px", margin: "0 auto" }}>
            Collaborating with leading organizations to transform education globally
          </p>
        </div>
        <div className="accred-grid reveal-stagger">
          {affiliations.map((item, i) => (
            <div key={i} className="accred-card">
              <div className="accred-icon" style={{ background: "#e0f2fe", color: "#0284c7" }}><FontAwesomeIcon icon={item.icon} /></div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Certifications */}
      <section style={{ padding: "80px 8%" }}>
        <div className="reveal" style={{ textAlign: "center", marginBottom: "48px" }}>
          <h2 style={{ fontFamily: "'Outfit', sans-serif", fontSize: "2.2rem", fontWeight: 800, color: "#0f172a", marginBottom: "8px" }}>
            Certification Types
          </h2>
          <p style={{ color: "#64748b", fontSize: "1.05rem", maxWidth: "600px", margin: "0 auto" }}>
            Multiple pathways to validate your expertise and achievement
          </p>
        </div>
        <div className="accred-grid reveal-stagger">
          {certTypes.map((item, i) => (
            <div key={i} className="accred-card">
              <div className="accred-icon" style={{ background: "#fef3c7", color: "#d97706" }}><FontAwesomeIcon icon={item.icon} /></div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="cta-banner">
        <div className="reveal">
          <h2>Partner With Us</h2>
          <p>Interested in accrediting your programs through our platform? Join our network of trusted education partners.</p>
          <Link to="/register?tab=partner" className="btn-cta">
            Become a Partner <FontAwesomeIcon icon={faHandshake} />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Accreditations;
